import React from "react";

export function NbButton({ children, variant = "primary", className = "", as: Comp = "button", ...props }) {
  const base = "inline-flex items-center justify-center gap-2 px-7 py-3 font-medium text-sm rounded-full transition-all duration-300 cursor-pointer select-none disabled:opacity-50 disabled:cursor-not-allowed active:scale-[0.98]";
  const variants = {
    primary: "bg-[#8B1E3F] text-white hover:bg-[#701530] shadow-sm hover:shadow-md",
    secondary: "bg-[#F3E8E6] text-[#8B1E3F] hover:bg-[#EBDAD7]",
    accent: "bg-[#D4AF37] text-[#1C1917] hover:brightness-105 shadow-sm",
    outline: "bg-transparent text-stone-900 border border-stone-300 hover:border-stone-900 hover:bg-stone-50",
    dark: "bg-[#1C1917] text-white hover:bg-black shadow-sm",
    danger: "bg-white text-[#B91C1C] border border-[#FCA5A5] hover:bg-[#FEF2F2]",
  };
  return (
    <Comp className={`${base} ${variants[variant]} ${className}`} {...props}>
      {children}
    </Comp>
  );
}

export function NbCard({ children, className = "", ...props }) {
  return (
    <div className={`bg-white rounded-2xl border border-stone-100 shadow-[0_8px_30px_rgb(28,25,23,0.05)] ${className}`} {...props}>
      {children}
    </div>
  );
}

export function NbInput({ className = "", ...props }) {
  return (
    <input
      className={`w-full bg-stone-50 border border-stone-200 rounded-xl px-4 py-3 text-stone-900 placeholder:text-stone-400 focus:outline-none focus:ring-2 focus:ring-[#8B1E3F]/15 focus:border-[#8B1E3F] transition-all ${className}`}
      {...props}
    />
  );
}

export function NbTextarea({ className = "", ...props }) {
  return (
    <textarea
      className={`w-full bg-stone-50 border border-stone-200 rounded-xl px-4 py-3 text-stone-900 placeholder:text-stone-400 focus:outline-none focus:ring-2 focus:ring-[#8B1E3F]/15 focus:border-[#8B1E3F] transition-all ${className}`}
      {...props}
    />
  );
}

export function NbSelect({ className = "", children, ...props }) {
  return (
    <select
      className={`w-full bg-stone-50 border border-stone-200 rounded-xl px-4 py-3 text-stone-900 focus:outline-none focus:ring-2 focus:ring-[#8B1E3F]/15 focus:border-[#8B1E3F] transition-all ${className}`}
      {...props}
    >
      {children}
    </select>
  );
}

export function NbBadge({ children, color = "#F3E8E6", className = "" }) {
  return (
    <span className={`inline-flex items-center gap-1 px-3 py-1 text-xs font-medium rounded-full ${className}`} style={{ background: color }}>
      {children}
    </span>
  );
}
